export default theme => ({
  question: {
    marginTop: 17,
    fontSize: 17,
  },
  snackbar: {
    position: 'absolute',
    margin: 5,
    //width:'100%',
    bottom: 5,
  },

  textField: {
    // backgroundColor: 'pink',
  },
  textFieldFocused: {
    // borderColor: '#2E5D96',
    borderColor: 'pink',
  },
});
